import { withLocalTransaction } from '../transact';
import { yMeta } from '../schema';

export function setTitle(doc, title) {
    withLocalTransaction(doc, () => yMeta(doc).set('title', title));
}

export function setDescription(doc, description) {
    withLocalTransaction(doc, () => yMeta(doc).set('description', description));
}

export function setDbEngine(doc, dbEngine) {
    withLocalTransaction(doc, () => yMeta(doc).set('dbEngine', dbEngine));
}
